import { OfferKind, OfferState } from "./types";

export const OFFER_KIND = [
  "automatic_offer",
  "bid_offer",
  "buyer_counteroffer",
  "seller_counteroffer",
  "house_offer",
  "instant_offer",
] as const;

export const MANUAL_INVESTOR_OFFER_KINDS: OfferKind[] = [
  "bid_offer",
  "buyer_counteroffer",
  "house_offer",
  "instant_offer",
];

export const OFFER_STATE = [
  "awaiting_acceptance",
  "awaiting_docs",
  "awaiting_due_diligence",
  "awaiting_payment",
  "awaiting_transfer",
  "countered",
  "filled",

  "fail_offer_rejected",
  "fail_offer_withdrawn",
  "fail_counteroffer_made",
  "fail_offer_timeout",

  "fail_buy_order_canceled",
  "fail_offer_increased",
  "fail_offer_rejected_by_increase",

  "fail_offer_auto_rejected",
  "fail_offer_auto_withdrawn",

  "fail_offer_outbid",

  "fail_auto_offer_upgraded",

  "fail_docs_timeout",

  "fail_due_diligence",
  "fail_due_diligence_timeout",

  "fail_payment",
  "fail_payment_timeout",

  "fail_transfer",

  "fail_new_gama_execution",
  "fail_kyw_offer_prioritized",

  "fail_publisher_matched",
] as const;

export const DUE_DILIGENCE_STATE = {
  pending: "awaiting_due_diligence",
  fail: [
    "fail_due_diligence",
    "fail_due_diligence_timeout",
    "fail_publisher_matched",
  ],
} as const;

export const PAYMENT_STATE = {
  pending: "awaiting_payment",
  fail: ["fail_payment", "fail_payment_timeout"],
} as const;

export const TRANSFER_STATE = {
  pending: "awaiting_transfer",
  fail: ["fail_transfer"],
} as const;

export const NON_FAILED_DEAL_STATES: Partial<OfferState>[] = [
  "awaiting_docs",
  "awaiting_due_diligence",
  "awaiting_payment",
  "awaiting_transfer",
  "filled",
];

export const FAILED_OFFER_STATES: Partial<OfferState>[] = [
  "fail_auto_offer_upgraded",
  "fail_buy_order_canceled",
  "fail_offer_increased",
  "fail_offer_rejected_by_increase",
  "fail_counteroffer_made",
  "fail_docs_timeout",
  "fail_due_diligence",
  "fail_due_diligence_timeout",
  "fail_kyw_offer_prioritized",
  "fail_new_gama_execution",
  "fail_offer_auto_rejected",
  "fail_offer_auto_withdrawn",
  "fail_offer_outbid",
  "fail_offer_rejected",
  "fail_offer_withdrawn",
  "fail_offer_timeout",
  "fail_payment",
  "fail_payment_timeout",
  "fail_publisher_matched",
  "fail_transfer",
];

export const NON_FAILED_DEAL_STATE_TO_DISPLAY_NAME = {
  awaiting_docs: "Awaiting Docs",
  awaiting_due_diligence: "Due Diligence & Documentation",
  awaiting_payment: "Buyer Payment Pending",
  awaiting_transfer: "Royalty Assignment Processing",
  filled: "Payment Sent & Transaction Complete",
};

export const ALL_DEAL_STATES = [
  "fail_offer_rejected",
  "fail_offer_timeout",
  "awaiting_docs",
  "fail_docs_timeout",
  "awaiting_due_diligence",
  "fail_due_diligence",
  "fail_due_diligence_timeout",
  "awaiting_payment",
  "fail_payment",
  "fail_payment_timeout",
  "awaiting_transfer",
  "fail_transfer",
  "filled",
] as const;

export const OFFER_STATUS = [
  "awaiting_acceptance",
  "accepted",
  "countered",
  "fail_offer_rejected",
  "fail_offer_withdrawn",
  "fail_counteroffer_made",
  "fail_offer_timeout",
  "fail_buy_order_canceled",
  "fail_offer_increased",
  "fail_offer_rejected_by_increase",
  "fail_offer_auto_rejected",
  "fail_offer_auto_withdrawn",
  "fail_auto_offer_upgraded",
  "fail_docs_timeout",
  "fail_due_diligence",
  "fail_due_diligence_timeout",
  "fail_payment",
  "fail_payment_timeout",
  "fail_transfer",
  "fail_new_gama_execution",
  "fail_kyw_offer_prioritized",
  "fail_publisher_matched",
];

export const LIVE_OFFER_STATES: OfferState[] = [
  "awaiting_acceptance",
  "countered",
];

export const ACTIVE_OFFER_STATES: OfferState[] = [
  ...LIVE_OFFER_STATES,
  ...NON_FAILED_DEAL_STATES,
];
